(function() {
  angular.module('dso')
  .controller('dsoAdminUserController', ['$uibModalInstance', 'user', '$uibModal', 'DsoUsers', '$scope','$filter','$timeout', 'gridServices', 'uiGridConstants', 'adminUsers',
   'secSecurityService', 'mode', 'selfView', function($uibModalInstance, user, $uibModal, DsoUsers, $scope, $filter, $timeout, gridServices, uiGridConstants, Users, securityService,
      mode, selfView) {
      var vm = this;
      vm.user = _.clone(user);
      vm.user.locations = [];
      vm.email = vm.user.unverifiedEmail ? vm.user.unverifiedEmail : vm.user.verifiedEmail;
      vm.mode = mode;
      vm.selfView = selfView;
      vm.running = false;
      vm.userManipulated = false;
      vm.close = close;
      vm.deleteAdmin = deleteAdmin;
      vm.submit = submit;
      vm.resendRegistrationInvite = resendRegistrationInvite;
      vm.emailResent = false;
      vm.goToMyProfile = goToMyProfile;
      securityService.hasAnyAuthority('PREVIOUS_ADMINISTRATOR').then((val) => {
        vm.inUserView = val;
      });
     
      vm.gridRunning = true;
      if(vm.mode === 'edit'){
        vm.auditEventsPromise = Users.getAuditEvents({userId: vm.user.userId}).$promise;
      }
      $scope.$on('authenticationChanged', () => {
        $uibModalInstance.dismiss();
      });

      function goToMyProfile() {
        $uibModalInstance.close({goToMyProfile: true});
      }

      $scope.$watch('vm.user', (change) => {
        if(change) {
          vm.userManipulated = true;
        }
      }, true);

      $scope.$on('modal.closing', function(event, reason, closed) {
        if (!(reason && (reason.add || reason.edit || reason.resend || reason.delete))) {
          if (vm.emailResent) {
              event.preventDefault();
              $uibModalInstance.close({resend: true, user: vm.user});
          }
        }
      });

      function close() {
        $scope.errorControl && $scope.errorControl.hideErrors();
        $uibModalInstance.dismiss('cancel');
      }
      $scope.$watch('errorControl', function() {
        $scope.errorControl && $scope.errorControl.showErrors('uniqueEmailAddress');
      });
      function submit() {
        $scope.errorControl.showErrors();
        if ($scope.addDsoUserForm.$valid) {
          if (vm.user.addUserMode) {
            delete vm.user.addUserMode;
          }
          if (vm.mode === 'add') {
            if (vm.email) {
              vm.user.unverifiedEmail = vm.email;
            }
            vm.running = true;
            DsoUsers.addDsoAdmin(vm.user, (result) => {
              $scope.dnConfirmationMessage.$show("Administrator has been successfully added.");
              $timeout(function () {
                $uibModalInstance.close({add: true});
              }, 1500);
            }, (error) => {
              vm.running = false;
              throw error;
            });
          }
          if (vm.mode === 'edit') {
            if (vm.userManipulated) {
              vm.running = true;
              DsoUsers.updateUser(vm.user, () => {
                $scope.errorControl.hideErrors();
                $scope.dnConfirmationMessage.$show("Administrator has been successfully updated.");
                $timeout(function () {
                  $uibModalInstance.close({edit: true});
                }, 1500);
              }, (error) => {
                vm.running = false;
                throw error;
              });
            }
          }
        }
      }

      function deleteAdmin() {
        $uibModal.open({
          controller:['$uibModalInstance', 'user', '$scope', function($uibModalInstance, user, $scope) {
            var self = this;
            self.user = user;
            self.delete = function() {
              $uibModalInstance.close(true);
            };
            self.close = function() {
              $uibModalInstance.dismiss();
            };
            $scope.$on('authenticationChanged', () => {
              $uibModalInstance.dismiss();
            });
          }],
          templateUrl: '/js/admin/confirmDelete.html' + appVersion,
          size: 'sm',
          animation: false,
          controllerAs: 'confirmation',
          resolve: {
            user: () => vm.user
          }
        }).result.then(function(val) {
          if (val) {
            $uibModalInstance.close({delete: true});
          }
        }, angular.noop);
      }

      function resendRegistrationInvite() {
        if(!$scope.addDsoUserForm.$valid) {
          $scope.errorControl && $scope.errorControl.showErrors();
          return;
        }
        vm.running=true;
        vm.emailResent = false;
        if(vm.mode === 'edit' && vm.user.status && vm.user.status === 'pending') {
          if(vm.email) {
            if (vm.user.unverifiedEmail && vm.email.toLowerCase() == vm.user.unverifiedEmail.toLowerCase()) {
              vm.email = vm.user.unverifiedEmail ;
            }else{
              vm.user.unverifiedEmail = vm.email;
            }
          }
          DsoUsers.resendRegistrationInvite({id: vm.user.id, unverifiedEmail: vm.user.unverifiedEmail}, function () {
            vm.running = false;
            vm.emailResent = true;
            $scope.errorControl.hideErrors();
            $scope.dnConfirmationMessage.$show("The Registration Invite has been sent.");
          },function(){
            vm.running = false;
          });
        }
      }
    }]);
})();
